import $ from 'jquery';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

$(function() {

  const $checkbox = document.getElementById('toggle-menu')
  const $nav = document.querySelector('.nav-primary');

  $checkbox.addEventListener('change', (event) => {
    if (event.currentTarget.checked) {
      disableBodyScroll( $nav );
    } else {
      clearAllBodyScrollLocks();
    }
  })
  
  // MOBILE NAV SUB MENU ACCORDION
  $('.nav-item span').click(function(e) {
    e.preventDefault();

    var $this = $(this);
    var $accordion = $this.parent();
    var $content = $this.next();

    $accordion.parent().find('.sub-nav').css('max-height', '0');

    if ($accordion.hasClass('open')) {
      $accordion.removeClass('open');
    } else {
      $accordion.siblings().removeClass('open');
      $accordion.addClass('open');
      $content.css('max-height', $content[0].scrollHeight);
    }
  });


  // DESKTOP HOVER STATE
  $('.nav-item:not(a)').hover(function(e) {
    $( this ).closest('.nav-primary').addClass('hover');
  }, function() {
    $( this ).closest('.nav-primary').removeClass('hover');
  });


  // CLONE NAV ON SCROLL
  // var $nav = document.querySelector('.nav-primary');
  var $navClone = $nav.cloneNode(true);
  var previousPosition = window.pageYOffset || document.documentElement.scrollTop;
  $navClone.classList.add('js-clone');
  $navClone.classList.add('fixed');
  $nav.parentNode.insertBefore($navClone, $nav.nextSibling);

  window.addEventListener('scroll', function() {

    var height = $navClone.offsetHeight;
    var currentPosition = window.pageYOffset || document.documentElement.scrollTop;

    if (currentPosition > height) {
      if (previousPosition > currentPosition) {
        $navClone.classList.add('scroll-up');
        $navClone.classList.remove('scroll-down');
      } else {
        $navClone.classList.add('scroll-down');
        $navClone.classList.remove('scroll-up');
      }
    } else {
      $navClone.classList.remove('scroll-up');
      $navClone.classList.remove('scroll-down');
    }

    previousPosition = currentPosition;
  });

  
  // FILTER CUSTOM DROPDOWN
  var dd = document.querySelectorAll('.dd');
  var elem = null;
  var dd_selector = '.dd-selection';
  
  dd.forEach(elem => {

    window.onclick = function(event) {
      if (!event.target.matches(dd_selector) && !event.target.closest('[data-keep-open]')) {
        clearDD()
      }
    }

    elem.querySelector(dd_selector).addEventListener("click", function() {
      if (!elem.classList.contains('open')) { clearDD() }
      elem.classList.toggle("open");
    })
  })

  function clearDD() {
    for (var i = 0; i < dd.length; i++) {
      if (dd[i].classList.contains('open')) {
        dd[i].classList.remove('open');
      }
    }
  }

  // Deeplinking ( Commerical Leasing )

  $( '.leasing-deeplink' ).on( 'click', () => {
    clearAllBodyScrollLocks();
  } )

})
